import { render, staticRenderFns } from "./dettaglioEC.vue?vue&type=template&id=01495d5b&scoped=true"
import script from "./dettaglioEC.vue?vue&type=script&lang=js"
export * from "./dettaglioEC.vue?vue&type=script&lang=js"
import style0 from "./dettaglioEC.vue?vue&type=style&index=0&id=01495d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01495d5b",
  null
  
)

export default component.exports